export default __webpack_public_path__ + "static/media/carousel3.42bbc996.png";